/* eslint-disable camelcase */

export const resolveShowStoryTab = (profileMeta, isEditable) => {
  if (!profileMeta) {
    return false;
  }

  const {
    education_xp,
    career_xp,
    finances_xp,
    relationships_xp,
    health_xp,
    story_documents,
    story_career,
    story_life,
    story_academic,
  } = profileMeta;

  const hasXpData = Boolean(
    education_xp?.length > 0
    || career_xp?.length > 0
    || finances_xp?.length > 0
    || relationships_xp?.length > 0
    || health_xp?.length > 0,
  );

  const hasStoryData = Boolean(
    story_documents?.length > 0
    || story_career?.length > 0
    || story_life?.length > 0
    || story_academic?.length > 0,
  );

  const showStoryTab = isEditable || hasXpData || hasStoryData;

  return showStoryTab;
};
